import script from "./SaveList.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveList.vue?vue&type=script&setup=true&lang=js"

import "./SaveList.vue?vue&type=style&index=0&id=ee52be6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee52be6e"]])

export default __exports__